import { MembershipDto, MembershipTierDto, UserToMembershipDto } from '../models/dto';
import { MembershipTierFrequencyEnum, UserToMembershipStatusEnum } from '../enums';

export const findMembershipByTierId = (memberships: MembershipDto[], tierId: string) =>
	memberships?.find((membership) => membership.tiers?.some((tier) => tier.id === tierId));

export const findMembershipTierById = (membershipTiers: MembershipTierDto[], tierId: string) =>
	membershipTiers?.find((tier) => tier.id === tierId);

export const findTierByIdFromMemberships = (memberships: MembershipDto[], tierId: string) => {
	let foundTier: MembershipTierDto | undefined;

	memberships?.forEach((membership) => {
		const tier = membership.tiers?.find((t) => t.id === tierId);

		if (tier) {
			foundTier = tier;
		}
	});

	return foundTier;
};

export const findMembershipTierByFrequency = (
	membershipTiers: MembershipTierDto[],
	tierFrequency: MembershipTierFrequencyEnum
) => membershipTiers?.find((tier) => tier.frequency === tierFrequency);

export const findUserToMembershipByCommunityId = (userMemberships: UserToMembershipDto[], communityId: string) =>
	userMemberships?.find((membership) => membership.membership?.mainCommunityId === communityId);

export const findUserToMembershipByTierId = (userMemberships: UserToMembershipDto[], tierId: string) =>
	userMemberships?.find((membership) => membership.membershipTierId === tierId);

export const getTierFrequencyName = (frequency?: MembershipTierFrequencyEnum): string | undefined => {
	switch (frequency) {
		case MembershipTierFrequencyEnum.Weekly:
			return 'Weekly';
		case MembershipTierFrequencyEnum.Monthly:
			return 'Monthly';
		case MembershipTierFrequencyEnum.Quarterly:
			return 'Quarterly';
		case MembershipTierFrequencyEnum.SemiAnnual:
			return 'Semi-Annual';
		case MembershipTierFrequencyEnum.Annual:
			return 'Annual';
		case MembershipTierFrequencyEnum.OneTime:
			return 'Lifetime';
		default:
			return undefined;
	}
};

export const calcMonthlyMembershipTierAmount = (tier?: MembershipTierDto): number | undefined => {
	switch (tier?.frequency) {
		case MembershipTierFrequencyEnum.Weekly:
			return tier.amount * 4;
		case MembershipTierFrequencyEnum.Monthly:
			return tier.amount;
		case MembershipTierFrequencyEnum.Quarterly:
			return tier.amount / 3;
		case MembershipTierFrequencyEnum.SemiAnnual:
			return tier.amount / 6;
		case MembershipTierFrequencyEnum.Annual:
			return tier.amount / 12;
		default:
			return undefined;
	}
};

export const getPeriodFromFrequency = (frequency?: MembershipTierFrequencyEnum): string | undefined => {
	switch (frequency) {
		case MembershipTierFrequencyEnum.Weekly:
			return 'week';
		case MembershipTierFrequencyEnum.Monthly:
			return 'month';
		case MembershipTierFrequencyEnum.Quarterly:
			return 'quarter';
		case MembershipTierFrequencyEnum.SemiAnnual:
			return 'semi-annual';
		case MembershipTierFrequencyEnum.Annual:
			return 'year';
		default:
			return undefined;
	}
};

export const getShortPeriodFromFrequency = (frequency?: MembershipTierFrequencyEnum): string | undefined => {
	switch (frequency) {
		case MembershipTierFrequencyEnum.Weekly:
			return '1 w';
		case MembershipTierFrequencyEnum.Monthly:
			return '1 mo';
		case MembershipTierFrequencyEnum.Quarterly:
			return '3 no';
		case MembershipTierFrequencyEnum.SemiAnnual:
			return '6 mo';
		case MembershipTierFrequencyEnum.Annual:
			return '1 y';
		default:
			return undefined;
	}
};

export const getUserToMembershipStatus = (userToMembership: UserToMembershipDto): UserToMembershipStatusEnum => {
	const { pauseFuturePayments, active } = userToMembership;

	return pauseFuturePayments
		? UserToMembershipStatusEnum.Canceled
		: active
			? UserToMembershipStatusEnum.Active
			: UserToMembershipStatusEnum.Finished;
};
